module.exports = __webpack_public_path__ + "static/media/nowinsg-mobile.8d9408f8.png";